import {Box} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import DashboardHeader from './DashboardHeader';
import {
  dashboardRootContainerStyle,
  dashboardContainerStyle,
  normalGridStyle,
  gridItemStyle,
  cardStyle,
} from './styles';

const DashboardOverviewSkeleton = () => (
  <Box sx={dashboardRootContainerStyle}>
    <Box sx={dashboardContainerStyle}>
      <DashboardHeader />
      <Box sx={normalGridStyle}>
        {[...Array(6)].map((_, idx) => (
          <Box sx={gridItemStyle} key={idx}>
            <Box sx={{...cardStyle, p: 3}}>
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="60%"
                height={32}
                animation="wave"
                sx={{mt: 2}}
              />
              <Skeleton
                variant="text"
                width="80%"
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="40%"
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={24}
                animation="wave"
                sx={{mt: 2, borderRadius: 1}}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

export default DashboardOverviewSkeleton;
